import { createContext } from 'react'
import { ABTestMap } from './ABTestMap'

export const ABTestingContext = createContext<ABTestMap>({})
